var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" }),
    React.createElement("path", { d: "M13.6782 14L2.67816 3M13.6782 14L10.1782 21C10.1343 21.0957 10.0638 21.1769 9.9752 21.2338C9.88657 21.2906 9.78347 21.3209 9.67815 21.3209C9.57284 21.3209 9.46973 21.2906 9.3811 21.2338C9.29247 21.1769 9.22203 21.0957 9.17815 21L2.67816 3M13.6782 14L20.6782 10.5C20.7739 10.4561 20.855 10.3857 20.9119 10.2971C20.9688 10.2084 20.999 10.1053 20.999 10C20.999 9.89468 20.9688 9.79158 20.9119 9.70295C20.855 9.61431 20.7739 9.54387 20.6782 9.5L2.67816 3", stroke: "#018489", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});